import storeConnector from '@store/storeConnector';
import '../Modes.scoped.scss';
import useAlias from '@alias';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import Button from '@src/components/_elements/Button/Button';
import PopupButton from '@src/components/_elements/Popup/PopupButton';
import { Actions } from '@src/types/Actions';
import { ModeStatus } from '@src/types/control-modes/Modes';
import { SiteMeta } from '@src/types/SiteMeta';
import { buttonStyles } from '../modes-utils';

interface FullConfigPopupButtonProps {
  actions: Actions;
  clearSCADASwitchState: () => void;
  SCADAModeToggle: ModeStatus;
  siteMeta: SiteMeta;
}

function ConfirmScadaPopupButton({
  actions,
  clearSCADASwitchState,
  SCADAModeToggle,
  siteMeta,
}: FullConfigPopupButtonProps) {
  const alias = useAlias();
  const popupContent = (close: () => void) => {
    const isSCADAModeEnabled = SCADAModeToggle === ModeStatus.Enabled;
    return (
      <div>
        <p>
          <FormattedAlias id='Are you sure you want to' />{' '}
          <b>
            <FormattedAlias id={isSCADAModeEnabled ? 'enable' : 'disable'} />
          </b>{' '}
          <FormattedAlias id='SCADA Mode' />?
        </p>
        <hr />
        <Button
          label={alias('Confirm')}
          style={{ background: '#d7d7d7' }}
          onClick={() => {
            actions.sendCommand(
              [
                `WriteToVariant::ControlMode_Authority::${
                  isSCADAModeEnabled ? 1 : 0
                }`,
              ],
              siteMeta.siteId,
            );
            clearSCADASwitchState();
            close();
          }}
        />
      </div>
    );
  };

  return (
    <PopupButton
      buttonStyles={buttonStyles}
      title={alias('Confirm SCADA Mode Config')}
      link
      content={popupContent}
      bodyClass='popup-body-class'
    >
      <FormattedAlias id='Save' />
    </PopupButton>
  );
}

export default storeConnector(ConfirmScadaPopupButton, {
  config: ['siteMeta'],
});
